export const FETCH_PLAYER_PROFILE = "FETCH_PLAYER_PROFILE";
export const FETCH_PLAYER_PROFILE_SUCCESS = "FETCH_PLAYER_PROFILE_SUCCESS";
export const RESET_PLAYER_PROFILE = "RESET_PLAYER_PROFILE";